/// <reference path="../../../app.definition.ts" />

import * as angular from 'angular';

/**
 * A directive that sets focus on an element based on a model value.
 * When the model assigned to the `focus-me` attribute becomes true, the element gains focus.
 * When the element loses focus (on blur), the model is set back to false.
 *
 * @usage <input type="text" ng-model="myModel" focus-me="isFocusRequested">
 */
function FocusMe($timeout: ng.ITimeoutService, $parse: ng.IParseService): ng.IDirective {
    return {
        restrict: 'A',
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
            const model = $parse(attrs.focusMe);

            scope.$watch(model, (value: boolean) => {
                if (value === true) {
                    // $timeout ensures this runs after the current digest cycle,
                    // giving the DOM time to be ready for the focus event.
                    $timeout(() => {
                        element[0].focus();
                    });
                }
            });

            // Use .on() which is the standard event handler registration method.
            element.on('blur', () => {
                // We need to wrap the model assignment in $apply to notify Angular
                // of a change that happened outside of its normal digest cycle (a DOM event).
                scope.$apply(() => {
                    model.assign(scope, false);
                });
            });
        }
    };
}

// This is crucial for production. It tells Angular what to inject
// even after a minifier renames the function parameters.
FocusMe.$inject = ['$timeout', '$parse'];

angular.module("eCareVault.common.directives").directive("focusMe", FocusMe);
